module.exports = __webpack_public_path__ + "static/media/step-mobile-1.9a03ca15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-mobile-1.png
// module id = 2214
// module chunks = 0